import initial from '../initial.js'
import { GIFT_SUBMITTED, GIFT_SUBMITTING, GIFT_ERROR } from '../actions/gift.js'

export default function gift(state = initial.gift, action) {
	switch (action.type) {
		case GIFT_SUBMITTING:
			return {
				...state,
				submitting: true,
				error: null
			}
		case GIFT_SUBMITTED:
			return {
				...state,
				submitting: false,
				submitted: true,
				error: null
			}
		case GIFT_ERROR:
			return {
				...state,
				submitting: false,
				error: action.payload
			}
		default:
			return state
	}
}
